export default "__VITE_ASSET__BGA0Kukz__"